export class ButtonState {
  public down = false;
  public pressed = false;
  public released = false;
}
